"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.warnings !== undefined)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)((_ctx.warnings || []), (warning, idx) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: idx,
                    class: "card-warning"
                }, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.descriptions[warning])), 1));
            }), 128))
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
